import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import App from './app';

import rootReducer from './app/Redux/Reducers';

import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import rootSaga from './app/Redux/Sagas';

const sagaMiddleware = createSagaMiddleware();

export const store = createStore(
    rootReducer,
    applyMiddleware(sagaMiddleware)
);

sagaMiddleware.run(rootSaga);
const root = ReactDOM.createRoot(document.getElementById('botForge'));
root.render(<Provider store={ store }><App /></Provider>);
